import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const generateRemoteUrl = (
  searchQuery?: string,
  selectedFlagFilters?: (string | number)[],
  selectedLanguageFilters?: string[]
) => {
  const params = new URLSearchParams();
  params.append("fetch_flags", "true");

  if (searchQuery) {
    params.append("search", searchQuery.toLowerCase());
  }

  if (selectedFlagFilters && selectedFlagFilters.length > 0) {
    params.append("flags", selectedFlagFilters.join(","));
  }

  if (selectedLanguageFilters && selectedLanguageFilters.length > 0) {
    params.append("language", selectedLanguageFilters.join(","));
  }

  return `users?${params.toString()}`;
};

export const languageOptions = (language: string) => [
  { value: "fr-FR", display: translate(language, "PAGES.USERS.LANGUAGES.FR") },
  { value: "en-US", display: translate(language, "PAGES.USERS.LANGUAGES.US") },
];

export const fetchFlags = (language: string, setUniqueFlags: Function, setLoadingFlags: Function) => {
  setLoadingFlags(true);
  ApiService.get("flags")
    .then((resp) => {
      setUniqueFlags(resp.data.flags);
    })
    .catch((error) => {
      console.error(error);
      alert(translate(language, "PAGES.USERS.FLAGS.ERROR"));
    })
    .finally(() => {
      setLoadingFlags(false);
    });
};
